import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { ButtonDeprecated, Checkbox, MetaMaskStatus, YatTile } from '@pkg/components';
import { useAppSelector, useMetaMask } from '@pkg/hooks';

import { ToolTip, Typography } from '../../../DesignSystem';
import '../NftSidePanel.scss';

export const Checkout = () => {
    const { t } = useTranslation(['nft', 'words', 'common', 'payment']);
    const { currentEmoji, currentRhythmScore } = useAppSelector((state) => state.userEmojis);
    const { isMetaMaskConnected } = useMetaMask();
    const [warningAcknowledged, setWarningAcknowledged] = useState(false);
    const [userHasEnoughFunds] = useState(true);
    const [gasAbsoluteAmount] = useState(0.0027);
    const [gasDollarAmount] = useState(10);

    return (
        <div className="yat-nft-sidebar__step yat-nft-sidebar__name-nft">
            <div className="yat-nft-sidebar__flex-item">
                <div className="yat-nft-sidebar__cart-container">
                    <div className="yat-nft-sidebar__checkout-row yat-nft-sidebar__header">
                        <div className="yat-nft-sidebar__checkout-left-cell">
                            <Typography type="label" size={14} classes={['yat-nft-sidebar__usd-amount']}>
                                {t('words:item')}
                            </Typography>
                        </div>
                        <div className="yat-nft-sidebar__checkout-right-cell">
                            <Typography type="label" size={18} classes={['yat-nft-sidebar__usd-amount']}>
                                {t('common:estimated_subtotal')}
                            </Typography>
                            {/* TODO: Fix background on tooltip overlapping with text */}
                            <ToolTip text={t('mint_estimated_fees_info')} classes={['yat-nft-sidebar__info-icon']}>
                                <div>?</div>
                            </ToolTip>
                        </div>
                    </div>

                    <div className="yat-nft-sidebar__line" />

                    <div className="yat-nft-sidebar__checkout-row yat-nft-sidebar__yat-row">
                        <div className="yat-nft-sidebar__checkout-left-cell">
                            <YatTile
                                forceSprite={true}
                                glow={true}
                                rhythmScore={currentRhythmScore}
                                showRhythmScore={false}
                                yat={currentEmoji}
                            />
                        </div>
                        <div className="yat-nft-sidebar__checkout-right-cell">
                            <Typography type="label" size={18}>
                                {gasAbsoluteAmount} {t('payment:eth')}
                            </Typography>
                            <Typography type="label" size={14} classes={['yat-nft-sidebar__usd-amount']}>
                                ${gasDollarAmount} {t('payment:usd')}
                            </Typography>
                        </div>
                    </div>

                    <div className="yat-nft-sidebar__line" />

                    <div className="yat-nft-sidebar__checkout-row yat-nft-sidebar__total-row">
                        <div className="yat-nft-sidebar__checkout-left-cell">
                            <Typography type="label" size={20}>
                                {t('payment:total')}
                            </Typography>
                        </div>
                        <div className="yat-nft-sidebar__checkout-right-cell">
                            <Typography type="label" size={18}>
                                {gasAbsoluteAmount} {t('payment:eth')}
                            </Typography>
                            <Typography type="label" size={14} classes={['yat-nft-sidebar__usd-amount']}>
                                ${gasDollarAmount} {t('payment:usd')}
                            </Typography>
                        </div>
                    </div>
                </div>

                <Checkbox
                    checked={warningAcknowledged}
                    onChange={(e) => setWarningAcknowledged(e.target.checked)}
                    id="nft-acknowledgement"
                >
                    {t('checkout_acknowledgement_checkbox')}
                </Checkbox>

                <ButtonDeprecated
                    classes={['nft-sidebar-cta-desktop']}
                    color="primary"
                    disabled={!warningAcknowledged || !userHasEnoughFunds}
                    // onClick={mintYat}
                    size="hero"
                >
                    {t('mint_my_yat')}
                </ButtonDeprecated>
                <ButtonDeprecated
                    classes={['nft-sidebar-cta-mobile']}
                    color="primary"
                    disabled={!warningAcknowledged}
                    fluid
                    // onClick={mintYat}
                    size="large"
                >
                    {t('mint_my_yat')}
                </ButtonDeprecated>
                {!userHasEnoughFunds && (
                    <p className="yat-nft-sidebar__error-text">{t('not_enough_funds_in_your_wallet')}</p>
                )}
            </div>
            {isMetaMaskConnected && <MetaMaskStatus classes={['yat-nft-sidebar__metamask-status']} />}
        </div>
    );
};
